// extracted by mini-css-extract-plugin
export default {"allPrices":"UserPurchaseTicketLot_allPrices__fBAtJ"};